import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                'companybank',
                () => import('./company-bank/company-bank.module').then(m => m.CompanyBankModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'enterpriseconfiguration',
                () => import('./enterprise-configuration/enterprise-configuration.module').then(m => m.EnterpriseConfigurationModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ]
    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
